import { render, staticRenderFns } from "./UpdateSabbaticalLeave.vue?vue&type=template&id=5199164f&scoped=true&"
import script from "./UpdateSabbaticalLeave.vue?vue&type=script&lang=js&"
export * from "./UpdateSabbaticalLeave.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSabbaticalLeave.vue?vue&type=style&index=0&id=5199164f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199164f",
  null
  
)

export default component.exports